import React from 'react'
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components'
import BuccaneerHeader from '../components/Home/BuccaneerHeader'
import About from '../components/Home/About'
import Team from '../components/Home/Team'
import ItemList from '../components/Home/ItemList'
import ImageContainer from '../components/Home/ImageContainer'
import ConnectBtn from '../components/B_ConnectBtn';
import DiscordBox from '../components/B_discordBox';
import Footer from '../components/B_footer';
// import { colors } from "../styles";

import chain from '../assets/images/chain.png';
import cubic from '../assets/images/cubic.png';
import dot from '../assets/images/dot.png';
import backgroundImg from '../assets/b-home/home-bg.jpg';
import homeTitle from '../assets/b-home/home-title.png';
import homeSmTitle from '../assets/b-home/home-sm-title.png';

const useStyles = makeStyles((theme) => ({
    motherWrap: {
        width: '100%',
        backgroundImage: `url(${backgroundImg})`,
        left: 0,
        right: 0,
        backgroundSize: 'cover',
        padding: '0 !important'
    },
    backWrap: {
        position: 'absolute',
        padding: '0px !important',
        margin: '0px !important'
    },
    mainWrap: {
        position: 'absolute',
    },
    backImg: {
        width: '100%',
        minWidth: 600
    },
    bannerWrap: {
        width: '100%',
        textAlign: 'center',
        marginTop: '20vh'
    },
    bannerTitle: {
        width: '100%'
    },
    bannerText: {
        width: '100%',
        color: 'white',
        fontSize: '24px',
        textAlign: 'center',
        lineHeight: 2
    },
    connectBtnWrap: {
        marginTop: '40px'
    },

    [theme.breakpoints.down("xs")]: {
        bannerWrap: {
            marginTop: '0vh'
        },
        connectBtnWrap: {
            marginTop: '5px'
        },
    },
    [theme.breakpoints.down("sm")]: {
        bannerText: {
            fontSize: '12px',
        },
        bannerWrap: {
            marginTop: '0vh'
        },
    },
    [theme.breakpoints.up("md")]: {
        bannerText: {
            fontSize: '18px',
        },
        bannerWrap: {
            marginTop: '10vh'
        },
    },
    [theme.breakpoints.up("lg")]: {
        bannerText: {
            fontSize: '24px',
        },
        bannerWrap: {
            marginTop: '20vh'
        },
    },

}));

interface Props {
    connect: () => void;
    setIsHide: (e: any) => void;
    killSession: () => void;
    isHide: boolean;
    connected: boolean;
    address: string;
    chainId: number;
}

const BannerTitle = styled.img`
    max-width: 1200px;
    width: 100%;
`

const Home = (props: Props) => {
    const classes = useStyles();
    return (
        <Container maxWidth="xl" className={classes.motherWrap}>
            <BuccaneerHeader
                connect={props.connect}
                isHide={props.isHide}
                setIsHide={(e: any) => props.setIsHide(e)}
                connected={props.connected}
                address={props.address}
                chainId={props.chainId}
                killSession={props.killSession}
            />
            <div className={classes.bannerWrap}>
                <BannerTitle src={homeTitle} alt="homeTitle" />
                <p className={classes.bannerText}>
                    8,888 beautiful sheep have been born on the ethereum blockchain, and they're yours for the taking! <br /> Hold a LAMBoze NFT so you can stake them for 10 $CHOPS a day, and gain access to our esteemed DAO community.
                </p>
                <div className={classes.connectBtnWrap}>
                    <ConnectBtn btn={"Connect to Wallet"} />
                </div>
            </div>
            <About />
            <Team />
            <div style={{ marginTop: 150 }}>
                <DiscordBox />
            </div>
            <Footer />
        </Container>
    )
}

export default Home
